(function () {
  var SECTION_ID = 'cart-recommendations';
  var LIMIT = 4;

  function recsUrl(productId, intent) {
    return (
      window.routes.productRecommendationsUrl +
      '?section_id=' +
      SECTION_ID +
      '&product_id=' +
      productId +
      '&limit=' +
      LIMIT +
      '&intent=' +
      intent
    );
  }

  function parseItems(html) {
    var wrap = document.createElement('div');
    wrap.innerHTML = html;
    return wrap.querySelector('.empress-cart-recs__items');
  }

  function hasCards(items) {
    return !!(items && items.querySelector('.product-upsell-wrapper'));
  }

  function applyItems(root, items) {
    var body = root.querySelector('.empress-cart-recs__body');
    if (!body || !hasCards(items)) {
      root.hidden = true;
      return false;
    }
    body.innerHTML = items.innerHTML;
    root.hidden = false;
    return true;
  }

  function loadRoot(root) {
    if (!root || root.getAttribute('data-empress-loaded') === '1') return;
    var productId = root.getAttribute('data-product-id');
    if (!productId || !window.routes || !window.routes.productRecommendationsUrl) return;

    root.setAttribute('data-empress-loaded', '1');

    fetch(recsUrl(productId, 'related'))
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        if (applyItems(root, parseItems(html))) return;
        return fetch(recsUrl(productId, 'complementary'))
          .then(function (response) {
            return response.text();
          })
          .then(function (htmlComplementary) {
            applyItems(root, parseItems(htmlComplementary));
          });
      })
      .catch(function () {
        root.hidden = true;
      });
  }

  function scan() {
    var roots = document.querySelectorAll('#sidebar-cart .empress-cart-recs');
    for (var i = 0; i < roots.length; i += 1) {
      loadRoot(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  document.documentElement.addEventListener('cart:refresh', function () {
    window.setTimeout(scan, 450);
  });

  var drawer = document.getElementById('sidebar-cart');
  if (drawer && typeof MutationObserver === 'function') {
    new MutationObserver(function () {
      scan();
    }).observe(drawer, { childList: true, subtree: true });
  }
})();
